var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatvia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 122,
    viewBox: "0 0 224 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 122,
    rx: 10,
    fill: "url(#pattern0_0_1035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_0_1035",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_1035",
    transform: "matrix(0.00330087 0 0 0.00606061 -0.0446429 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_1035",
    width: 330,
    height: 165,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAAClAQMAAAAAgialAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABlBMVEWdIjX///941e63AAAAAWJLR0QB/wIt3gAAAAd0SU1FB+gGFwwwJJ4Sgo8AAAApSURBVFjD7cohAQAACAMw+qeiGVTAoL7pVQEAQLy5alVVVfWpAgBAvAXv3FzDJXTYgwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyNC0wNi0yM1QxMjo0ODozNSswMDowMLL/ldsAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjQtMDYtMjNUMTI6NDg6MzUrMDA6MDDDoi1nAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatvia);
export default __webpack_public_path__ + "static/media/latvia.7a373d204e4337e714fd4a8bc343de74.svg";
export { ForwardRef as ReactComponent };